import getEnvVariableValue, { VARIABLES } from 'src/utils/getEnvVariableValue'

export default function getOldMonLink(endpoint = '', isCustomer) {
    if (isCustomer) {
        return `https://${getEnvVariableValue(VARIABLES.OLD_CCP_HOSTNAME)}${endpoint}?sso=true`
    }
    return `https://${getEnvVariableValue(VARIABLES.OLD_MON_HOSTNAME)}${endpoint}?sso=true`
}
